import Modal, { ModalProps } from './Modal';
import { usePopupStore } from '@/stores/PopupStore';
import React, { FC, ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 24px;
  height: 24px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 16px;
    height: 2px;
    background-color: #666;
  }
  &::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
`;

const PopupBody = styled.div`
  white-space: pre-wrap;
  text-align: center;
  padding: 32px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: -0.8px;
`;

const PopupFooter = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 32px;
  > * {
    margin: 0 20px;
  }
`;

interface PopupModalProps extends ModalProps {
  message?: ReactNode;
  footer?: ReactElement;
  showCloseButton?: boolean;
}

const PopupModal: FC<PopupModalProps> = ({
  message,
  footer,
  showCloseButton,
  ...props
}) => {
  const popupStore = usePopupStore();

  return (
    <Modal
      dismissable
      maxWidth="400px"
      {...props}
      zIndex={popupStore.isOpen ? '1000' : '100'}
    >
      {showCloseButton && (
        <CloseButton onClick={() => popupStore.onClose(false)} />
      )}
      <PopupBody>{message}</PopupBody>
      <PopupFooter>{footer}</PopupFooter>
    </Modal>
  );
};

export default PopupModal;
